import DIApi from './_diApi';

class TopicAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Topics';
}
export default new TopicAPI();
